import { render, staticRenderFns } from "./NewFunction.vue?vue&type=template&id=0da799b6&scoped=true&"
import script from "./NewFunction.vue?vue&type=script&lang=js&"
export * from "./NewFunction.vue?vue&type=script&lang=js&"
import style0 from "./NewFunction.vue?vue&type=style&index=0&id=0da799b6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da799b6",
  null
  
)

export default component.exports